export const arrowLeftPath = "<path d=\"M13 8 H3 M7 4 L3 8 L7 12\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
